import React, { useState } from 'react';
import './App.css';
import { Button, Card, Grid, Typography, AppBar, Toolbar, Box, Container, TextField, Link } from '@mui/material';
import Logo from './logo.svg';
import { Carousel } from 'react-responsive-carousel';
import ProductSection from './ProductSection';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // For Carousel styles
import ServiceSection from './ServiceSection';
import ContactPage from './ContactSection';

// Dummy image URL for cards and sections
const dummyImageUrl = 'https://img.freepik.com/free-vector/blue-futuristic-networking-technology_53876-100679.jpg';

const ServiceCard = ({ title, description, imageUrl }) => (
  <Card sx={{ padding: 2, textAlign: 'center', boxShadow: 5, borderRadius: 2, backgroundImage: `url(${imageUrl})`, backgroundSize: 'cover', height: '250px', color: 'white', transition: 'transform 0.3s ease', '&:hover': { transform: 'scale(1.05)' } }}>
    <Typography variant="h5" gutterBottom>{title}</Typography>
    <Typography variant="body1">{description}</Typography>
  </Card>
);




const App = () => {
  return (
    <div className="App">
      {/* Navigation Bar */}
      <AppBar position="sticky" sx={{ backgroundColor: '#111', boxShadow: 3 }}>
        <Toolbar sx={{ justifyContent: 'space-between', padding: '0 40px' }}>
          {/* Logo on the left */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img src={Logo} alt="Invislabs Logo" style={{ width: 50, height: 50, marginRight: 10 }} />
            <Typography variant="h6" color="inherit" sx={{ fontWeight: 'bold' }}>
              Invislabs
            </Typography>
          </Box>
          {/* Navigation buttons on the right */}
          <Box sx={{ display: 'flex', gap: 4 }}>
            <Button color="inherit" href="#home">Home</Button>
            <Button color="inherit" href="#services">Services</Button>
            <Button color="inherit" href="#products">Products</Button>
            <Button color="inherit" href="#contact">Contact</Button>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Background Image Carousel Section */}
      <section id="home" className="intro-section">
        <Carousel
          infiniteLoop
          autoPlay
          showThumbs={false}
          showStatus={false}
          interval={5000}
        >
          <div style={{ backgroundImage: 'url(https://imageio.forbes.com/specials-images/imageserve/61d52d4e3a76ed81ac034ea8/The-10-Tech-Trends-That-Will-Transform-Our-World/960x0.jpg?height=399&width=711&fit=bounds)', backgroundSize: 'cover', height: '80vh' }}>
            <div className="carousel-content" style={{ textAlign: 'center', color: 'white', paddingTop: '30vh' }}>
              <Typography variant="h3" color="inherit">
                Welcome to Invislabs
              </Typography>
              <Typography variant="h5" color="inherit" paragraph sx={{ maxWidth: '600px', margin: 'auto' }}>
                Your Trusted Partner in Technology Innovation
              </Typography>
            </div>
          </div>
        </Carousel>
      </section>

     
      {/* Services Section */}
      <ServiceSection></ServiceSection>

      {/* Products Section */}
    <  ProductSection></ProductSection>

      {/* Contact Section */}
      <ContactPage />

      {/* Standard Bottom Section */}
      <section style={{ backgroundColor: '#111', color: 'white', padding: '40px 20px' }}>
        <Container >
          <Grid container spacing={4}>
            {/* Info Column */}
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                About Invislabs
              </Typography>
              <Typography variant="body1" paragraph>
                Invislabs is at the forefront of innovation, providing cutting-edge solutions in cybersecurity, cloud computing, and app development. Our mission is to help businesses stay ahead with the latest technology trends.
              </Typography>
            </Grid>

            {/* Quick Links Column */}
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                Quick Links
              </Typography>
              <Grid container direction="column" spacing={1}>
                <Grid item><Link href="#services" color="inherit">Services</Link></Grid>
                <Grid item><Link href="#products" color="inherit">Products</Link></Grid>
                <Grid item><Link href="#contact" color="inherit">Contact Us</Link></Grid>
                <Grid item><Link href="#home" color="inherit">Home</Link></Grid>
              </Grid>
            </Grid>

            {/* Social Links Column */}
            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                Follow Us
              </Typography>
              <Grid container direction="column" spacing={1}>
                <Grid item><Link href="#" color="inherit">Facebook</Link></Grid>
                <Grid item><Link href="#" color="inherit">Twitter</Link></Grid>
                <Grid item><Link href="#" color="inherit">Instagram</Link></Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </section>

      {/* Footer */}
      <footer style={{ backgroundColor: '#111', color: 'white', padding: '20px 0', textAlign: 'center' }}>
        <Typography variant="body1">
          &copy; 2024 Invislabs. All rights reserved.
        </Typography>
      </footer>
    </div>
  );
}

export default App;
